export const PRICE_QUALIFIERS = [
  { value: 'guide_price', label: 'Guide price', prefix: 'Guide price' },
  { value: 'asking_price', label: 'Asking price', prefix: 'Asking price' },
  { value: 'offers_over', label: 'Offers over', prefix: 'Offers over' },
  { value: 'offers_in_excess', label: 'Offers in excess of', prefix: 'Offers in excess of' },
  { value: 'offers_in_region', label: 'Offers in region of', prefix: 'Offers in region of' },
  { value: 'offers_invited', label: 'Offers invited', prefix: 'Offers invited' },
  { value: 'fixed_price', label: 'Fixed price', prefix: 'Fixed price' },
  { value: 'price_on_application', label: 'Price on application', prefix: 'Price on application', hideAmount: true },
  { value: 'offers_under', label: 'Offers under', prefix: 'Offers under' },
]

export const PRICE_QUALIFIER_MAP = PRICE_QUALIFIERS.reduce((acc, option) => {
  acc[option.value] = option
  return acc
}, {})
